export default "__VITE_ASSET__tlLeGsHb__"